/* eslint-disable camelcase */
jQuery(document).ready(function ($) {
	const $root = $('.insights-filter');
	if (!$root.length) {
		return;
	}

	const $contentInner = $root.find('.insights-filter__content-inner');
	const $preloader = $root.find('.preloader');
	const $drawer = $root.find('.insights-filter__drawer');
	const $mobileBar = $root.find('.insights-filter__mobile-bar');
	const $mobileBarIcon = $root.find('.insights-filter__mobile-bar-icon-img');
	const postsPerPage = $root.data('per-page') || 17;
	const injectCta = parseInt($root.data('inject-cta'), 10) || 0;
	const gridCta = $root.data('grid-cta') || null;
	let selectedSlugs = getSelectedFromDom();

	updateMobileBarIcon();

	$root.on('click', '.insights-filter__tab', function () {
		const tab = $(this).data('tab');
		$root.find('.insights-filter__tab').removeClass('is-active').attr('aria-selected', 'false');
		$(this).addClass('is-active').attr('aria-selected', 'true');
		$root.find('.insights-filter__chips').removeClass('is-active').attr('hidden', true);
		$root.find('.insights-filter__chips[data-chips="' + tab + '"]')
			.addClass('is-active')
			.removeAttr('hidden');
	});

	$root.on('click', '.insights-filter__chip', function () {
		const slug = $(this).data('slug');
		$(this).toggleClass('is-selected');
		$(this).attr('aria-pressed', $(this).hasClass('is-selected') ? 'true' : 'false');

		if (selectedSlugs.indexOf(slug) === -1) {
			selectedSlugs.push(slug);
		} else {
			selectedSlugs = selectedSlugs.filter(function (value) {
				return value !== slug;
			});
		}

		syncChipState();
	});

	$root.on('click', '.insights-filter__clear', function () {
		selectedSlugs = [];
		syncChipState();
		applyFilters(1);
		closeDrawer();
	});

	$root.on('click', '.insights-filter__apply', function () {
		applyFilters(1);
		closeDrawer();
	});

	$root.on('click', '.pagination__page', function (e) {
		if (
			$(this).hasClass('disabled') ||
			$(this).hasClass('pagination__page--ellipsis') ||
			$(this).find('.pagination__elipsis').length
		) {
			return;
		}
		e.preventDefault();
		const pageNum = parseInt($(this).data('paged'), 10);
		if (!pageNum) {
			return;
		}
		applyFilters(pageNum, true);
	});

	$mobileBar.on('click', function () {
		openDrawer();
	});

	$root.on('click', '.insights-filter__drawer-close, .insights-filter__drawer-backdrop', function () {
		closeDrawer();
	});

	// Hash links on in-grid CTA: scroll without writing # into the URL
	// (also covers AJAX-injected cards that miss the header.js bind).
	$root.on('click', '.insights-grid-cta__button', function (e) {
		const href = $(this).attr('href') || '';
		const hashIndex = href.indexOf('#');
		if (hashIndex === -1) {
			return;
		}

		const hash = href.slice(hashIndex);
		if (!hash || hash === '#') {
			return;
		}

		let target = null;
		try {
			target = document.querySelector(hash);
		} catch (err) {
			return;
		}
		if (!target) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		const header = document.querySelector('header');
		const offset = header ? header.offsetHeight : 0;
		const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
		window.scrollTo({ top: top, behavior: 'smooth' });
	});

	$(document).on('keydown.insightsFilterDrawer', function (event) {
		if (event.key === 'Escape' && $drawer.hasClass('is-open')) {
			closeDrawer();
		}
	});

	function openDrawer() {
		$drawer.addClass('is-open').attr('aria-hidden', 'false');
		$mobileBar.attr('aria-expanded', 'true');
		$('body').addClass('insights-filter-drawer-open');
	}

	function closeDrawer() {
		$drawer.removeClass('is-open').attr('aria-hidden', 'true');
		$mobileBar.attr('aria-expanded', 'false');
		$('body').removeClass('insights-filter-drawer-open');
	}

	function getSelectedFromDom() {
		const slugs = [];
		$root.find('.insights-filter__chip.is-selected').each(function () {
			const slug = $(this).data('slug');
			if (slug && slugs.indexOf(slug) === -1) {
				slugs.push(slug);
			}
		});
		return slugs;
	}

	function syncChipState() {
		$root.find('.insights-filter__chip').each(function () {
			const slug = $(this).data('slug');
			const selected = selectedSlugs.indexOf(slug) !== -1;
			$(this).toggleClass('is-selected', selected);
			$(this).attr('aria-pressed', selected ? 'true' : 'false');
		});
		updateMobileBarIcon();
	}

	function updateMobileBarIcon() {
		if (!$mobileBarIcon.length) {
			return;
		}
		const hasFilters = selectedSlugs.length > 0;
		const nextSrc = hasFilters
			? $mobileBarIcon.data('icon-active')
			: $mobileBarIcon.data('icon-default');
		if (nextSrc && $mobileBarIcon.attr('src') !== nextSrc) {
			$mobileBarIcon.attr('src', nextSrc);
		}
		$mobileBar.toggleClass('has-filters', hasFilters);
	}

	function updateUrl(page) {
		let cleanPathname = window.location.pathname.replace(/\/page\/\d+\/?$/, '');
		cleanPathname = cleanPathname.replace(/\/$/, '') || '/trends-and-insights';

		let newUrl = cleanPathname;
		if (page > 1) {
			newUrl += '/page/' + page + '/';
		} else {
			newUrl += '/';
		}
		if (selectedSlugs.length) {
			newUrl += '?filters=' + selectedSlugs.map(encodeURIComponent).join(',');
		}
		history.pushState(null, '', newUrl);
	}

	function scrollToFilterTop() {
		const headerHeight = $('header').outerHeight() || 0;
		const top = $root.offset() ? $root.offset().top - headerHeight : 0;
		$('html, body').animate({ scrollTop: Math.max(0, top) }, 400);
	}

	function applyFilters(page, shouldScroll) {
		if (typeof ajax_object === 'undefined') {
			return;
		}

		updateUrl(page);
		$root.addClass('is-loading');
		if ($preloader.length) {
			$preloader.addClass('animate');
		}

		const ajaxData = {
			action: 'filter_insights',
			terms: selectedSlugs,
			page: page,
			posts_per_page: postsPerPage,
			card: 'insights-filter-card',
			inject_cta_position: injectCta,
		};

		if (gridCta && gridCta.enabled) {
			ajaxData.grid_cta_heading = gridCta.heading || '';
			ajaxData.grid_cta_text = gridCta.text || '';
			ajaxData.grid_cta_url = gridCta.link_url || '';
			ajaxData.grid_cta_title = gridCta.link_title || '';
			ajaxData.grid_cta_target = gridCta.link_target || '';
			ajaxData.grid_cta_background = gridCta.background_id || 0;
		}

		$.ajax({
			url: ajax_object.ajax_url,
			type: 'GET',
			data: ajaxData,
			success: function (response) {
				if (response && response.success) {
					$contentInner.html(response.data);
					if (shouldScroll) {
						scrollToFilterTop();
					}
				}
			},
			complete: function () {
				$root.removeClass('is-loading');
				if ($preloader.length) {
					$preloader.removeClass('animate');
				}
			},
		});
	}
});
